export default __webpack_public_path__ + "static/media/productW.498f98a9.jpg";